/* global instantsearch, algoliasearch */

const TECHGALA_PAGINATION_ARROW_SVG =
	'<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">' +
	'<path d="M12 1L4 9L12 17" fill="white"/>' +
	'<path d="M12 1L4 9L12 17" stroke="black" stroke-width="2"/>' +
	'</svg>';

/**
 * セッション検索 UI を初期化する
 *
 * @param {Object} config
 * @param {string} config.appId        Algolia Application ID
 * @param {string} config.searchApiKey Algolia Search-Only API Key
 * @param {string} config.indexName    Algolia Index Name
 */
function techgalaInitSessionSearch( config ) {
	const appId        = config.appId;
	const searchApiKey = config.searchApiKey;
	const indexName    = config.indexName;
	const lang         = config.lang || '';
	const keywordLabels = config.keywordLabels || {};
	const stageLabels   = config.stageLabels   || {};
	const stageOrder    = config.stageOrder    || [];
	const themeLabels   = config.themeLabels   || {};

	const langLabels = { jp: 'JP', en: 'EN', kr: 'KR', both: 'JP/EN' };

	function techgalaEscHtml( str ) {
		return String( str )
			.replace( /&/g, '&amp;' )
			.replace( /</g, '&lt;' )
			.replace( />/g, '&gt;' )
			.replace( /"/g, '&quot;' );
	}

	function techgalaDecodeHtmlEntities( str ) {
		const el = document.createElement( 'textarea' );
		el.innerHTML = String( str );
		return el.value;
	}

	function techgalaTranslateTermLabel( rawLabel, labelMap ) {
		const decoded = techgalaDecodeHtmlEntities( String( rawLabel ) );
		return ( 'en' === lang && labelMap[ decoded ] ) ? labelMap[ decoded ] : decoded;
	}

	function init() {
		const container = document.getElementById( 'techgala-search-main' );
		if ( ! container ) return;

		const searchClient = algoliasearch( appId, searchApiKey );

		const search = instantsearch( {
			indexName:    indexName,
			searchClient: searchClient,
			future: { preserveSharedStateOnUnmount: true },
		} );

		const deferredRefinementLists = [];

		function techgalaEscAttr( str ) {
			return String( str )
				.replace( /&/g, '&amp;' )
				.replace( /</g, '&lt;' )
				.replace( />/g, '&gt;' )
				.replace( /"/g, '&quot;' );
		}

		function techgalaCreateDeferredRefinementList( options ) {
			const containerSel  = options.container;
			const transformItem = options.transformItem || function ( item ) { return item; };
			// 既定の 10 件だと、Algolia が件数の多い順に上位 10 件しか返さず、
			// 該当件数の少ない項目が絞り込みから漏れるため、全項目が収まる件数を既定にする.
			const limit         = options.limit || 100;
			const sortBy        = options.sortBy || [ 'name:asc' ];
			const cssClasses    = options.cssClasses || {};

			// options.order（値の配列）が指定されていればその順で並べる。
			const orderMap = new Map();
			( options.order || [] ).forEach( function ( name, index ) {
				const key = techgalaDecodeHtmlEntities( name );
				if ( ! orderMap.has( key ) ) orderMap.set( key, index );
			} );
			function orderIndex( item ) {
				const key = techgalaDecodeHtmlEntities( item.value );
				return orderMap.has( key ) ? orderMap.get( key ) : Number.MAX_SAFE_INTEGER;
			}

			const itemCache = new Map(); // value -> { label, highlighted, value, count, isRefined }
			let pendingValues  = new Set();
			let latestRefineFn = null;

			function extraCls( key ) {
				return cssClasses[ key ] ? ' ' + cssClasses[ key ] : '';
			}

			function renderList() {
				const containerEl = document.querySelector( containerSel );
				if ( ! containerEl ) return;

				let displayItems = Array.from( itemCache.values() ).map( function ( item ) {
					return Object.assign( {}, item, { isRefined: pendingValues.has( item.value ) } );
				} );

				displayItems.sort( function ( a, b ) {
					if ( orderMap.size ) {
						const diff = orderIndex( a ) - orderIndex( b );
						if ( 0 !== diff ) return diff;
					}
					return String( a.label ).localeCompare( String( b.label ), 'ja' );
				} );

				if ( limit ) {
					displayItems = displayItems.slice( 0, limit );
				}

				// 絞り込みの項目が1件も無い場合は、見出しごとセクションを非表示にする.
				const sectionEl = containerEl.closest( '.search-sidebar__section' );
				if ( sectionEl ) {
					sectionEl.hidden = ! displayItems.length;
				}

				containerEl.innerHTML =
					'<div class="ais-RefinementList' + extraCls( 'root' ) + '">' +
						'<ul class="ais-RefinementList-list' + extraCls( 'list' ) + '">' +
							displayItems.map( function ( item ) {
								const selectedCls = item.isRefined ? ' ais-RefinementList-item--selected' + extraCls( 'selectedItem' ) : '';
								return (
									'<li class="ais-RefinementList-item' + extraCls( 'item' ) + selectedCls + '">' +
										'<label class="ais-RefinementList-label' + extraCls( 'label' ) + '">' +
											'<input type="checkbox" class="ais-RefinementList-checkbox' + extraCls( 'checkbox' ) + '" value="' + techgalaEscAttr( item.value ) + '"' + ( item.isRefined ? ' checked' : '' ) + '>' +
											'<span class="ais-RefinementList-labelText">' + techgalaEscAttr( item.highlighted != null ? item.highlighted : item.label ) + '</span>' +
											'<span class="ais-RefinementList-count' + extraCls( 'count' ) + '">' + item.count + '</span>' +
										'</label>' +
									'</li>'
								);
							} ).join( '' ) +
						'</ul>' +
					'</div>';

				containerEl.querySelectorAll( 'input[type=checkbox]' ).forEach( function ( input ) {
					input.addEventListener( 'change', function () {
						if ( input.checked ) {
							pendingValues.add( input.value );
						} else {
							pendingValues.delete( input.value );
						}
						const li = input.closest( '.ais-RefinementList-item' );
						if ( li ) {
							li.classList.toggle( 'ais-RefinementList-item--selected', input.checked );
							if ( cssClasses.selectedItem ) {
								cssClasses.selectedItem.split( ' ' ).forEach( function ( c ) {
									if ( c ) li.classList.toggle( c, input.checked );
								} );
							}
						}
					} );
				} );
			}

			function render( renderOptions ) {
				const items = renderOptions.items;
				latestRefineFn = renderOptions.refine;

				items.forEach( function ( item ) {
					itemCache.set( item.value, transformItem( item ) );
				} );

				pendingValues = new Set();
				items.forEach( function ( item ) {
					if ( item.isRefined ) pendingValues.add( item.value );
				} );

				const currentValues = new Set( items.map( function ( item ) { return item.value; } ) );
				itemCache.forEach( function ( cached, value ) {
					if ( ! currentValues.has( value ) ) {
						itemCache.set( value, Object.assign( {}, cached, { count: 0 } ) );
					}
				} );

				renderList();
			}

			function applyPending() {
				if ( ! latestRefineFn ) return;
				const actualValues = new Set();
				itemCache.forEach( function ( item ) {
					if ( item.isRefined ) actualValues.add( item.value );
				} );
				const toToggle = new Set();
				pendingValues.forEach( function ( v ) { if ( ! actualValues.has( v ) ) toToggle.add( v ); } );
				actualValues.forEach( function ( v ) { if ( ! pendingValues.has( v ) ) toToggle.add( v ); } );
				toToggle.forEach( function ( v ) { latestRefineFn( v ); } );
			}

			const widget = instantsearch.connectors.connectRefinementList( render )( {
				attribute: options.attribute,
				operator:  'or',
				limit:     limit,
				sortBy:    sortBy,
			} );

			deferredRefinementLists.push( { applyPending: applyPending } );

			return widget;
		}


		const configureParams = { hitsPerPage: 50 };
		if ( lang ) {
			configureParams.filters = 'post_lang:' + lang;
		}

		const sessionWeekdayLabels = {
			Mon: '月',
			Tue: '火',
			Wed: '水',
			Thu: '木',
			Fri: '金',
			Sat: '土',
			Sun: '日',
		};

		function techgalaFormatSessionDayLabel( rawLabel ) {
			if ( ! rawLabel ) return rawLabel;
			return String( rawLabel ).replace(
				/^(Day\d+)\s+(\d{4}\/\d{2}\/\d{2})\s+(Mon|Tue|Wed|Thu|Fri|Sat|Sun)$/,
				function ( match, day, date, weekday ) {
					if ( 'en' === lang ) {
						return day + '：' + date + ' ' + weekday;
					}
					return day + '：' + date + '（' + ( sessionWeekdayLabels[ weekday ] || weekday ) + '）';
				}
			);
		}

		search.addWidgets( [
			instantsearch.widgets.configure( configureParams ),

			techgalaCreateDeferredRefinementList( {
				container:       '#techgala-search-filter-date',
				attribute:       'date_label',
				sortBy:          [ 'name:asc' ],
				transformItem: function ( item ) {
					const label = techgalaFormatSessionDayLabel( item.label );
					return Object.assign( {}, item, {
						label:       label,
						highlighted: label,
					} );
				},
				cssClasses: {
					root:       'search-sessions-refinement search-refinement',
					list:       'search-sessions-refinement__list search-refinement__list',
					item:       'search-sessions-refinement__item search-refinement__item',
					label:      'search-sessions-refinement__label search-refinement__label',
					checkbox:   'search-sessions-refinement__checkbox search-refinement__checkbox',
					count:      'search-sessions-refinement__count search-refinement__count',
					selectedItem: 'search-sessions-refinement__item--selected search-refinement__item--selected',
				},
			} ),

			techgalaCreateDeferredRefinementList( {
				container:      '#techgala-search-filter-stage',
				attribute:      'taxonomies.session_stage',
				sortBy:         [ 'name:asc' ],
				order:          stageOrder,
				transformItem: function ( item ) {
					const raw   = Array.isArray( item.label ) ? item.label[ 0 ] : item.label;
					const label = techgalaTranslateTermLabel( raw, stageLabels );
					return Object.assign( {}, item, {
						label:       label,
						highlighted: label,
					} );
				},
				cssClasses: {
					root:         'search-sessions-refinement search-refinement',
					list:         'search-sessions-refinement__list search-refinement__list',
					item:         'search-sessions-refinement__item search-refinement__item',
					label:        'search-sessions-refinement__label search-refinement__label',
					checkbox:     'search-sessions-refinement__checkbox search-refinement__checkbox',
					count:        'search-sessions-refinement__count search-refinement__count',
					selectedItem: 'search-sessions-refinement__item--selected search-refinement__item--selected',
				},
			} ),

			techgalaCreateDeferredRefinementList( {
				container: '#techgala-search-filter-theme',
				attribute: 'taxonomies.exhibitors_theme',
				sortBy:    [ 'name:asc' ],
				transformItem: function ( item ) {
					const label = techgalaTranslateTermLabel( Array.isArray( item.label ) ? item.label[ 0 ] : item.label, themeLabels );
					return Object.assign( {}, item, {
						label:       label,
						highlighted: label,
					} );
				},
				cssClasses: {
					root:         'search-sessions-refinement search-refinement',
					list:         'search-sessions-refinement__list search-refinement__list',
					item:         'search-sessions-refinement__item search-refinement__item',
					label:        'search-sessions-refinement__label search-refinement__label',
					checkbox:     'search-sessions-refinement__checkbox search-refinement__checkbox',
					count:        'search-sessions-refinement__count search-refinement__count',
					selectedItem: 'search-sessions-refinement__item--selected search-refinement__item--selected',
				},
			} ),

			techgalaCreateDeferredRefinementList( {
				container: '#techgala-search-filter-keyword',
				attribute: 'taxonomies.session_keyword',
				sortBy:    [ 'name:asc' ],
				transformItem: function ( item ) {
					const label = techgalaTranslateTermLabel( Array.isArray( item.label ) ? item.label[ 0 ] : item.label, keywordLabels );
					return Object.assign( {}, item, {
						label:       label,
						highlighted: label,
					} );
				},
				cssClasses: {
					root:         'search-sessions-refinement search-refinement',
					list:         'search-sessions-refinement__list search-refinement__list',
					item:         'search-sessions-refinement__item search-refinement__item',
					label:        'search-sessions-refinement__label search-refinement__label',
					checkbox:     'search-sessions-refinement__checkbox search-refinement__checkbox',
					count:        'search-sessions-refinement__count search-refinement__count',
					selectedItem: 'search-sessions-refinement__item--selected search-refinement__item--selected',
				},
			} ),

			techgalaCreateDeferredRefinementList( {
				container:       '#techgala-search-filter-lang',
				attribute:       'language',
				sortBy:          [ 'name:asc' ],
				transformItem:  function ( item ) {
					const key   = String( item.label ).toLowerCase();
					const label = langLabels[ key ] || String( item.label ).toUpperCase();
					return Object.assign( {}, item, {
						label:       label,
						highlighted: label,
					} );
				},
				cssClasses: {
					root:       'search-sessions-refinement search-refinement',
					list:       'search-sessions-refinement__list search-refinement__list',
					item:       'search-sessions-refinement__item search-refinement__item',
					label:      'search-sessions-refinement__label search-refinement__label',
					checkbox:   'search-sessions-refinement__checkbox search-refinement__checkbox',
					count:      'search-sessions-refinement__count search-refinement__count',
					selectedItem: 'search-sessions-refinement__item--selected search-refinement__item--selected',
				},
			} ),

			instantsearch.widgets.hits( {
				container: '#techgala-search-hits',
				cssClasses: {
					root:     'search-sessions-hits',
					list:     'search-sessions-hits__list',
					item:     'search-sessions-hits__item',
					empty:    'search-sessions-hits__empty',
				},
				templates: {
					item: function ( hit ) {
						const title     = hit.post_title || hit.title || '';
						const permalink = hit.permalink  || hit.link  || '#';

						if ( ! title && permalink === '#' ) return '<div></div>';

						const highlightedTitle = (
							hit._highlightResult &&
							hit._highlightResult.post_title &&
							hit._highlightResult.post_title.value
						) ? hit._highlightResult.post_title.value : techgalaEscHtml( title );

						const sessionNumber   = hit.session_number ? String( hit.session_number ).toUpperCase() : '';
						const hasTranslation  = !! hit.has_translation;
						const lang      = hit.language ? ( langLabels[ String( hit.language ).toLowerCase() ] || String( hit.language ).toUpperCase() ) : '';
						const langClass = hit.language ? ' search-sessions-card__lang--' + hit.language : '';
						const translationLabel = ( 'en' === config.lang ) ? 'Translations' : '翻訳あり';

						const themaArr  = ( hit.taxonomies || {} ).exhibitors_theme || [];
						const themaTags = themaArr.map( function ( name ) {
							return '<span class="search-sessions-card__tag">' + techgalaEscHtml( techgalaTranslateTermLabel( name, themeLabels ) ) + '</span>';
						} ).join( '' );

						const rawExcerpt = hit.excerpt || hit.post_excerpt || '';
						const excerpt    = rawExcerpt.length > 120
							? rawExcerpt.slice( 0, 120 ) + '…'
							: rawExcerpt;

						const speakers = ( hit.speakers || [] ).map( function ( sp ) {
							const imgSrc  = sp.image || sp.thumbnail || '';
							const img     = imgSrc
								? '<img src="' + techgalaEscHtml( imgSrc ) + '" alt="' + techgalaEscHtml( sp.name ) + '" class="search-sessions-card__speaker-img">'
								: '';
							const spExcerpt = sp.excerpt
								? '<p class="search-sessions-card__speaker-excerpt">' + techgalaEscHtml( sp.excerpt ) + '</p>'
								: '';
							const inner = img
								+ '<div class="search-sessions-card__speaker-info">'
								+ '<p class="search-sessions-card__speaker-name">' + techgalaEscHtml( sp.name ) + '</p>'
								+ spExcerpt
								+ '</div>';
							return sp.link
								? '<a href="' + techgalaEscHtml( sp.link ) + '" class="search-sessions-card__speaker" onclick="event.stopPropagation()">' + inner + '</a>'
								: '<span class="search-sessions-card__speaker">' + inner + '</span>';
						} ).join( '' );


						const stageVals = ( hit.taxonomies || {} ).session_stage || [];
						const mainStageVal = Array.isArray( stageVals ) ? stageVals[ 0 ] : stageVals;
						const stageNames = mainStageVal ? techgalaEscHtml( techgalaTranslateTermLabel( String( mainStageVal ), stageLabels ) ) : '';
						const timeStr    = hit.start_time
							? hit.start_time + ( hit.end_time ? '〜' + hit.end_time : '' )
							: '';
						const formattedDate = hit.date_label ? techgalaFormatSessionDayLabel( hit.date_label ) : '';
						const dateTime   = [ formattedDate, timeStr ].filter( Boolean ).join( ' ' );

						const card = document.createElement( 'div' );
						card.className = 'search-sessions-card';
						card.setAttribute( 'role', 'link' );
						card.setAttribute( 'tabindex', '0' );
						card.setAttribute( 'data-href', permalink );

						card.innerHTML =
							'<div class="search-sessions-card__body">' +
								'<a href="' + techgalaEscHtml( permalink ) + '" class="search-sessions-card__link"></a>' +
								'<div class="search-sessions-card__top-meta">' +
									( sessionNumber ? '<span class="search-sessions-card__number">' + techgalaEscHtml( sessionNumber ) + '</span>' : '' ) +
									( themaTags ? '<div class="search-sessions-card__tags">' + themaTags + '</div>' : '' ) +
									( ( hasTranslation || lang )
										? '<div class="search-sessions-card__lang-group">' +
											( hasTranslation ? '<span class="search-sessions-card__translation">' + techgalaEscHtml( translationLabel ) + '</span>' : '' ) +
											( lang ? '<span class="search-sessions-card__lang' + techgalaEscHtml( langClass ) + '">' + techgalaEscHtml( lang ) + '</span>' : '' ) +
										'</div>'
										: '' ) +
								'</div>' +
								'<h3 class="search-sessions-card__title">' + highlightedTitle + '</h3>' +
								'<div class="search-sessions-card__info">' +
								( dateTime ? '<span class="search-sessions-card__time">' + techgalaEscHtml( dateTime ) + '</span>' : '' ) +
								( stageNames ? '<span class="search-sessions-card__stage">' + stageNames + '</span>' : '' ) +
								'</div>' +
								( speakers ? '<div class="search-sessions-card__speakers">' + speakers + '</div>' : '' ) +
							'</div>';

						card.addEventListener( 'click', function ( e ) {
							if ( e.target.closest( 'a' ) ) return; // リンク要素は個別処理
							window.location.href = permalink;
						} );
						card.addEventListener( 'keydown', function ( e ) {
							if ( e.key === 'Enter' || e.key === ' ' ) window.location.href = permalink;
						} );

						return card.outerHTML;
					},
					empty: '<p class="search-sessions-hits__empty-text">該当するセッションが見つかりませんでした。</p>',
				},
			} ),

			instantsearch.widgets.currentRefinements( {
				container: '#techgala-search-current-refinements',
				cssClasses: {
					root:     'search-sessions-current-refinements search-current-refinements',
					list:     'search-sessions-current-refinements__list search-current-refinements__list',
					item:     'search-sessions-current-refinements__item search-current-refinements__item',
					label:    'search-sessions-current-refinements__label search-current-refinements__label',
					category: 'search-sessions-current-refinements__category search-current-refinements__category',
					delete:   'search-sessions-current-refinements__delete search-current-refinements__delete',
				},
				transformItems: function ( items ) {
					return items.map( function ( item ) {
						if ( item.attribute === 'language' ) {
							return Object.assign( {}, item, {
								refinements: item.refinements.map( function ( r ) {
									const key   = String( r.label ).toLowerCase();
									const label = langLabels[ key ] || String( r.label ).toUpperCase();
									return Object.assign( {}, r, {
										label: label,
									} );
								} ),
							} );
						}
						if ( item.attribute === 'taxonomies.session_stage' ) {
							return Object.assign( {}, item, {
								refinements: item.refinements.map( function ( r ) {
									return Object.assign( {}, r, {
										label: techgalaTranslateTermLabel( r.label, stageLabels ),
									} );
								} ),
							} );
						}
						if ( item.attribute === 'taxonomies.exhibitors_theme' ) {
							return Object.assign( {}, item, {
								refinements: item.refinements.map( function ( r ) {
									return Object.assign( {}, r, {
										label: techgalaTranslateTermLabel( r.label, themeLabels ),
									} );
								} ),
							} );
						}
						if ( item.attribute === 'taxonomies.session_keyword' ) {
							return Object.assign( {}, item, {
								refinements: item.refinements.map( function ( r ) {
									return Object.assign( {}, r, {
										label: techgalaTranslateTermLabel( r.label, keywordLabels ),
									} );
								} ),
							} );
						}
						return item;
					} );
				},
			} ),

			instantsearch.widgets.clearRefinements( {
				container:       '#techgala-search-clear',
				excludedAttributes: [],
				cssClasses: {
					root:   'search-sessions-clear search-clear',
					button: 'search-sessions-clear__btn search-clear__btn',
					disabledButton: 'search-sessions-clear__btn--disabled search-clear__btn--disabled',
				},
				templates: {
					resetLabel: config.clearLabel || 'クリア',
				},
			} ),

			instantsearch.widgets.pagination( {
				container: '#techgala-search-pagination',
				showFirst: false,
				showLast: false,
				cssClasses: {
					root:               'search-sessions-pagination search-pagination',
					list:               'search-sessions-pagination__list search-pagination__list',
					item:               'search-sessions-pagination__item search-pagination__item',
					previousPageItem:   'search-sessions-pagination__item--previous search-pagination__item--previous',
					pageItem:           'search-sessions-pagination__item--page search-pagination__item--page',
					selectedItem:       'search-sessions-pagination__item--selected search-pagination__item--selected',
					nextPageItem:       'search-sessions-pagination__item--next search-pagination__item--next',
					disabledItem:       'search-sessions-pagination__item--disabled search-pagination__item--disabled',
					link:               'search-sessions-pagination__link search-pagination__link',
				},
				templates: {
					previous: TECHGALA_PAGINATION_ARROW_SVG,
					next:     TECHGALA_PAGINATION_ARROW_SVG,
				},
			} ),
		] );

		search.start();

		const paginationEl = document.getElementById( 'techgala-search-pagination' );
		if ( paginationEl ) {
			search.on( 'render', function () {
				const results = search.helper.lastResults;
				paginationEl.style.display = ( results && results.nbPages > 1 ) ? '' : 'none';
			} );
		}

		document.querySelectorAll( '.search-sessions-sidebar__toggle' ).forEach( function ( btn ) {
			btn.addEventListener( 'click', function () {
				const expanded = this.getAttribute( 'aria-expanded' ) === 'true';
				this.setAttribute( 'aria-expanded', String( ! expanded ) );
				let body = this.nextElementSibling;
				while ( body && ! body.classList.contains( 'search-sessions-sidebar__body' ) ) {
					body = body.nextElementSibling;
				}
				if ( body ) {
					body.hidden = expanded;
				}
			} );
		} );

		const filterToggleBtn = document.getElementById( 'techgala-search-filter-toggle' );
		const sidebarEl       = document.getElementById( 'techgala-search-sidebar' );
		const sidebarCloseBtn = document.getElementById( 'techgala-search-sidebar-close' );

		function openFilterPanel() {
			if ( ! sidebarEl ) return;
			sidebarEl.classList.add( 'is-open' );
			document.body.classList.add( 'search-filter-panel-open' );
			if ( filterToggleBtn ) filterToggleBtn.setAttribute( 'aria-expanded', 'true' );
		}

		function closeFilterPanel() {
			if ( ! sidebarEl ) return;
			sidebarEl.classList.remove( 'is-open' );
			document.body.classList.remove( 'search-filter-panel-open' );
			if ( filterToggleBtn ) filterToggleBtn.setAttribute( 'aria-expanded', 'false' );
		}

		if ( filterToggleBtn ) {
			filterToggleBtn.addEventListener( 'click', openFilterPanel );
		}

		if ( sidebarCloseBtn ) {
			sidebarCloseBtn.addEventListener( 'click', closeFilterPanel );
		}

		document.addEventListener( 'keydown', function ( e ) {
			if ( e.key === 'Escape' && sidebarEl && sidebarEl.classList.contains( 'is-open' ) ) {
				closeFilterPanel();
			}
		} );

		const searchInput = document.getElementById( 'techgala-search-input' );
		const searchBtn   = document.getElementById( 'techgala-search-btn' );
		const resetBtn    = document.getElementById( 'techgala-search-reset-btn' );

		function doSearch() {
			if ( searchInput ) {
				search.helper.setQuery( searchInput.value );
			}
			deferredRefinementLists.forEach( function ( list ) { list.applyPending(); } );
			search.helper.search();
		}

		// 検索ボタンを押したら、スマホで開いている絞り込みパネルを閉じて結果を見せる
		// （展示者検索 search-exhibitors.js と同じ挙動）.
		if ( searchBtn ) {
			searchBtn.addEventListener( 'click', function () {
				doSearch();
				closeFilterPanel();
			} );
		}

		if ( searchInput ) {
			searchInput.addEventListener( 'keydown', function ( e ) {
				if ( e.key === 'Enter' ) doSearch();
			} );
		}

		if ( resetBtn ) {
			resetBtn.addEventListener( 'click', function () {
				if ( searchInput ) searchInput.value = '';
				search.helper.setQuery( '' );
				search.helper.search();
			} );
		}

		const clearEl = document.getElementById( 'techgala-search-clear' );
		if ( clearEl ) {
			clearEl.addEventListener( 'click', function ( e ) {
				const btn = e.target.closest( '.ais-ClearRefinements-button:not(.ais-ClearRefinements-button--disabled)' );
				if ( btn ) {
					if ( searchInput ) searchInput.value = '';
					search.helper.setQuery( '' );
				}
			}, true ); // capture phase でウィジェットより先に実行
		}
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
}

window.techgalaInitSessionSearch = techgalaInitSessionSearch;
